/**
 * @module SessionConstants
 * @requires keyMirror
 */

import keyMirror from 'keymirror';

/**
 * @const SessionConstants
 */
export default keyMirror({
  REQUEST_AUTHENTICATION_UPDATE: null,

  REQUEST_ACCESS_CHALLENGE_CREATE: null,
  REQUEST_ACCESS_CHALLENGE_CREATE_SUCCESS: null,
  REQUEST_ACCESS_CHALLENGE_CREATE_ERROR: null,

  REQUEST_ACCESS_CHALLENGE_MISSING_DETAILS_ERROR: null,

  REQUEST_ACCESS_CHALLENGE_RESET: null,

  REQUEST_ACCESS_TOKEN_CREATE: null,
  REQUEST_ACCESS_TOKEN_CREATE_SUCCESS: null,
  REQUEST_ACCESS_TOKEN_CREATE_ERROR: null,
  REQUEST_ACCESS_TOKEN_MULTIPLE_ATTEMPTS_ERROR: null,

  REQUEST_ACCESS_TOKEN_RESET: null,
  REQUEST_ACCESS_TOKEN_RESET_SUCCESS: null,

  REQUEST_OTP_AUTHENTICATION: null,
  REQUEST_OTP_ERROR: null,
  REQUEST_OTP_SUCCESS: null,
  REQUEST_OTP_AUTHENTICATION_RESET: null,
  REQUEST_CURRENT_USER_PHONE_NUMBER: null,
  REQUEST_CURRENT_USER_PHONE_NUMBER_SUCCESS: null,

  LOG_USER_IN: null,
  REQUEST_PUBLIC_KEY: null,
  REQUEST_PUBLIC_KEY_SUCCESS: null,

  REQUEST_BANK_ID: null,
  UPDATE_BANK_ID: null,

  GET_CURRENT_USER: null,

  REQUEST_FIND_DETAILS_CHALLENGE_CREATE: null,
  ACCOUNT_LOCKED_ERROR: null,
  SESSION_TIMEOUT: null,
  RESET_SESSION_TIMEOUT: null,
  SET_MALWARE_VALUES: null,

  // Added constant for ID&V changes
  UPDATE_URL_ACCESS_TOKEN: null,
  SESSION_BANK_ID_CALL: null,
  SESSION_BANK_ID_SUCCESS: null,
  SESSION_BANK_ID_ERROR: null,
  //Ended ID&V changes
  SET_PW_REMINDER_VALUE: null,

  STEP_UP_MODE_INIT: null,
  STEP_UP_CLEAR_SESSION: null,
  REQUEST_PREFERRED_OTP_NUMBER: null,
  REQUEST_PREFERRED_OTP_NUMBER_SUCCESS: null,
  SUBMIT_OTP: null,
});
